import { TOUR_BASE_QUERY_KEY } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';

export const tourClientsApiQueryKeys = {
  tourClients: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, 'clients'] as const,
};
